import { openModal } from '../../../../actions/modal.action';

const FilterSample404Dialog = (dispatch) => {
  openModal({
    className: 'modal-alert-width',
    button1Text: 'Close',
    button1Action: 'closeModal',
    imageSrc: '/art-error-message.svg',
    body: 'ERROR: The current filter has no sample or dimension in the database.',
  })(dispatch);
};

export default FilterSample404Dialog;
